import React, { Component, createRef } from 'react';
import ReactGA from 'react-ga';
import { withRouter } from 'react-router-dom'
import {Helmet} from 'react-helmet';
import SectionList from './SectionList';
import { ParallaxProvider } from 'react-scroll-parallax';
import { isMobile  } from 'react-device-detect';
import LOGO_712 from '../../sections/Logo_712/Logo';
import MENU_713 from '../../sections/Menu_713/Menu';
import SD_SECTION1_322 from '../../sections/SD_Section1_322/SD_Section1';
import SD_SECTION2_324 from '../../sections/SD_Section2_324/SD_Section2';
import SD_SECTION3_564 from '../../sections/SD_Section3_564/SD_Section3';
import SD_SECTION4_328 from '../../sections/SD_Section4_328/SD_Section4';
import SD_SECTION6_435 from '../../sections/SD_Section6_435/SD_Section6';
import SD_SECTION5_608 from '../../sections/SD_Section5_608/SD_Section5';
import FOOTER_316 from '../../sections/Footer_316/Footer';
import SectionShortcut from './SectionShortcut/SectionShortcut';
import HomeSectionShortcut from './SectionShortcut/HomeSectionShortcut';
import styled from 'styled-components';

const MainClass = styled.div`
     min-height: 100vh;
     background: white;
     position: relative;
     z-index: 1;
     box-shadow: 0px 3px 6px #00000029;
`;

class project1 extends Component {
   constructor(props) {
       super(props);
       this.state = {
           currentPage: null,
           currentSection: null,
           override: true,
           darkSection: false,
          section: [
               { id: 1, title: localStorage.getItem('language') === "English"? 'Foundation' : 'Nền Tảng', slug: localStorage.getItem('language') === "English"? 'foundation' : 'nen-tang', has_shortcut: false},
               { id: 2, title: localStorage.getItem('language') === "English"? 'Commitment' : 'Cam Kết Ptbv', slug: localStorage.getItem('language') === "English"? 'commitment' : 'cam-ket-ptbv', has_shortcut: true},
               { id: 3, title: localStorage.getItem('language') === "English"? 'Orientation' : 'Định Hướng Ptbv', slug: localStorage.getItem('language') === "English"? 'orientation' : 'dinh-huong-ptbv', has_shortcut: true},
               { id: 4, title: localStorage.getItem('language') === "English"? 'Stakeholders' : 'Gắn Kết Các Bên Liên Quan', slug: localStorage.getItem('language') === "English"? 'stakeholders' : 'gan-ket-cac-ben-lien-quan', has_shortcut: true},
               { id: 5, title: localStorage.getItem('language') === "English"? 'Action' : 'Hoạt Động Ptbv', slug: localStorage.getItem('language') === "English"? 'action' : 'hoat-dong-ptbv', has_shortcut: true},
               { id: 6, title: localStorage.getItem('language') === "English"? 'Reports' : 'Báo Cáo Ptbv', slug: localStorage.getItem('language') === "English"? 'reports' : 'bao-cao-ptbv', has_shortcut: true},
          ],
       activeSection: 'Section1',
       };
       this.updateLogo = this.updateLogo.bind(this)
       this.override1 = this.override1.bind(this)
       this.override2 = this.override2.bind(this)
       this.override3 = this.override3.bind(this)
       this.override4 = this.override4.bind(this)
       this.override5 = this.override5.bind(this)
       this.override6 = this.override6.bind(this)
        this.scrollToSection = this.scrollToSection.bind(this)
        this.scrollingHandler = this.scrollingHandler.bind(this)
        this.isStateChanging = false
   }
   componentDidMount() {
       ReactGA.initialize('G-R7TGZTN26B')
       ReactGA.pageview(window.location.pathname + window.location.search);
        window.addEventListener('scroll', this.scrollingHandler, true);
          this.scrollToSection()
   }
   componentWillUnmount(){
       window.removeEventListener('scroll', this.scrollingHandler, true);
   }
     section1 = createRef()
     section2 = createRef()
     section3 = createRef()
     section4 = createRef()
     section5 = createRef()
     section6 = createRef()
   updateLogo(value) {
       this.setState({
           darkSection: value,
       })
   }
   override1(value) {
       this.setState({
       override: value,
       })
   }

   override2(value) {
       this.setState({
       override: value,
       })
   }

   override3(value) {
       this.setState({
       override: value,
       })
   }

   override4(value) {
       this.setState({
       override: value,
       })
   }

   override5(value) {
       this.setState({
       override: value,
       })
   }

   override6(value) {
       this.setState({
       override: value,
       })
   }

     scrolltoSectionHandler = (key) => {
       if (key === 'section1') {
           this.section1.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'});
       } else if (key === 'section2') {
           this.section2.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'});
       } else if (key === 'section3') {
           this.section3.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'});
       } else if (key === 'section4') {
           this.section4.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'});
       } else if (key === 'section5') {
           this.section5.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'});
       } else if (key === 'section6') {
           this.section6.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'});
      }
   };
    scrollingHandler() {
        const sectionsName = ['section1', 'section2', 'section3', 'section4', 'section5', 'section6'];
        const isSectionsDarkLogo = [
       {
           name: 'Section1',
           darkSection: false
       },
       {
           name: 'Section2',
           darkSection: false
       },
       {
           name: 'Section3',
           darkSection: false
       },
       {
           name: 'Section4',
           darkSection: false
       },
       {
           name: 'Section5',
           darkSection: false
       },
       {
           name: 'Section6',
           darkSection: false
       },
        ]
       isSectionsDarkLogo.forEach((sec, i) => {
           let section = this[sectionsName[i]]?.current?.getBoundingClientRect();
           if (section && section.bottom < section.height && section.bottom > -1 && !this.isStateChanging) {
               this.setState({
                   activeSection: sec.name
               })
               if (this.state.darkSection !== sec.darkSection && this.state.currentSection !== sec.name) {
                   this.isStateChanging = true
                   this.setState({
                       currentSection: sec.name,
                       darkSection: sec.darkSection,
                   }, () => {
                       this.isStateChanging = false
                   })
               }
           }
       })
    }
   scrollToSection() {
       let currentLocation = window.location.href
       const hasSectionAnchor = currentLocation.includes('/#')
       const hasTabAnchor = currentLocation.includes('*')
       if (hasSectionAnchor) {
           let anchorSectionId = `${currentLocation.substring(currentLocation.indexOf('#') + 1)}`
           if (hasTabAnchor) {
                const tabSectionId = `${anchorSectionId.substring(anchorSectionId.indexOf('*') + 1)}`
                anchorSectionId = anchorSectionId.substring(0, anchorSectionId.length - 2)
                setTimeout(() => { this.scrollAction(anchorSectionId) }, 1000)
                this.setState({ tabsActive: tabSectionId })
            } else {
                setTimeout(() => { this.scrollAction(anchorSectionId) }, 1000)
            }
        } else {
           setTimeout(() => {window.scrollTo(0, 0)}, 1000)
           this.setState({
               activeSection: 'Section1',
               currentSection: null,
           })
        }
   }
    scrollAction(anchorSectionId) {
       const uri_dec = decodeURIComponent(anchorSectionId)
       const key = this.state.section.filter(x => x.slug == uri_dec).map(obj => `section${obj.id}`)
       if (key) {
                if (key[0] === 'section1') {
                    setTimeout(() => {this.section1.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'})}, 1000)
                } else if (key[0] === 'section2') {
                    setTimeout(() => {this.section2.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'})}, 1000)
                } else if (key[0] === 'section3') {
                    setTimeout(() => {this.section3.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'})}, 1000)
                } else if (key[0] === 'section4') {
                    setTimeout(() => {this.section4.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'})}, 1000)
                } else if (key[0] === 'section5') {
                    setTimeout(() => {this.section5.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'})}, 1000)
                } else if (key[0] === 'section6') {
                    setTimeout(() => {this.section6.current.scrollIntoView({'behavior': 'smooth', 'block': 'start'})}, 1000)
                }
       }
   }
   render() {
       let AllSections = [];
       if (this.state.section) {
           this.state.section.map((s, i) => {
               let section;
               switch (i) {
                   case 0:
                       section = (
                           <div ref={this.section1}>
                               <SD_SECTION1_322
                                   updateLogo={this.updateLogo}
                                   override={this.override1}
                                   darkSection={this.state.darkSection}
                               />
                           </div>
                       );
                       break;
                   case 1:
                       section = (
                           <div ref={this.section2}>
                               <SD_SECTION2_324
                                   updateLogo={this.updateLogo}
                                   override={this.override2}
                                   darkSection={this.state.darkSection}
                               />
                           </div>
                       );
                       break;
                   case 2:
                       section = (
                           <div ref={this.section3}>
                               <SD_SECTION3_564
                                   updateLogo={this.updateLogo}
                                   override={this.override3}
                                   darkSection={this.state.darkSection}
                               />
                           </div>
                       );
                       break;
                   case 3:
                       section = (
                           <div ref={this.section4}>
                               <SD_SECTION4_328
                                   updateLogo={this.updateLogo}
                                   override={this.override4}
                                   darkSection={this.state.darkSection}
                               />
                           </div>
                       );
                       break;
                   case 4:
                       section = (
                           <div ref={this.section5}>
                               <SD_SECTION6_435
                                   updateLogo={this.updateLogo}
                                   override={this.override5}
                                   darkSection={this.state.darkSection}
                               />
                           </div>
                       );
                       break;
                   case 5:
                       section = (
                           <div ref={this.section6}>
                               <SD_SECTION5_608
                                   updateLogo={this.updateLogo}
                                   override={this.override6}
                                   darkSection={this.state.darkSection}
                               />
                           </div>
                       );
                       break;
                       default:
                           break;
                   }
           AllSections.push(section);
           });
       }
       let sec = this.state.section.filter(sec => sec.has_shortcut === true).map((s, i) => {
           let activeDot = this.state.activeSection === 'Section' + (i) ? true : false
           let ref = 'section' + s.id
           return (
               <SectionShortcut
                   key={s.id}
                   title={s.title}
                   activeDot={activeDot}
                   onClick={() => this.scrolltoSectionHandler(ref)}
               />
           );
       });
       let homeSectionShortcut = !isMobile? <HomeSectionShortcut section={sec}  /> : null 
         let helmet = localStorage.getItem('language') === "English" ? <title> Sustainable Development | Phenikaa</title> : <title> Phát triển bền vững | Phenikaa</title>
         let description = localStorage.getItem('language') === "English" ? <meta name="description" content="Phenikaa constantly strive to foster a conscious business which is responsible, humane and caring to make the life better" /> : <meta name="description" content="Phenikaa nỗ lực không ngừng để góp phần xây dựng một doanh nghiệp có ý thức, trách nhiệm, nhân văn, sẻ chia vì cuộc sống tốt đẹp hơn" />
         let keywords = localStorage.getItem('language') === "English" ? <meta name="keywords" content="Phenikaa, Phenikaa Group, Our Commitment. Your Reality" /> : <meta name="keywords" content="Phenikaa, Tập đoàn Phenikaa, Hiện thực hóa mọi cam kết" />
       return (
           <div style={{}}>
               <Helmet>
                   {helmet}
                   {description}
                   {keywords}
               </Helmet>
               <LOGO_712 logoColor={this.state.darkSection}/>
               <MENU_713 logoColor={this.state.darkSection}/>
               <MainClass>
                   <ParallaxProvider >
                       <React.Fragment>
                               {AllSections.length > 0 ? (
                                   <SectionList sections={AllSections} />
                               ) : (
                                   <></>
                               )}
                       </React.Fragment>
                   </ParallaxProvider>
               </MainClass>
               <FOOTER_316/>
               {homeSectionShortcut}
           </div>
       );
   }
}
export default withRouter(project1);